module.exports = require('./helpers/bundle-url').getBundleURL('iNcwZ') + "logo.c51670a8.svg";